import React, { useState } from "react";
import "./App.scss";
import { HomeHercSection } from "./components/HomeHercSection";
import { VideoSection } from "./components/VideoSection";
import { AboutUs } from "./components/AboutUs";
import { GetAQuote } from "./components/GetAQuote";
import { PresentationSection } from "./components/PresentationSection";
import { AdditionalProducts } from "./components/AdditionalProducts";
import { Footer } from "./components/Footer";
import { NavBar } from "./components/NavBar";
import { Modal, Input } from "antd";
import ContactLogo from "./assets/logo-Pillar.webp";
import EmbedImg from "./assets/pillarEmbed.webp";

import { Helmet } from "react-helmet";
import axios from "axios";
import { Tag } from "antd";

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  const [formSuccess, setFormSuccess] = useState(false);
  const [formFailed, setFormFailed] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const { TextArea } = Input;

  async function sendEmail(e) {
    console.log("submit1", document.getElementById("name").value);
    e.preventDefault();
    await axios
      .post(`https://www.alpacasys.com/form/sendPillarEmail`, {
        name: document.getElementById("name").value,
        phone: document.getElementById("phone").value,
        email: document.getElementById("email").value,
        message: document.getElementById("message").value,
      })
      .then((res) => {
        setFormSuccess(true);
        document.getElementById("name").value = "";
        document.getElementById("phone").value = "";
        document.getElementById("email").value = "";
        document.getElementById("message").value = "";
      })
      .catch((err) => {
        setFormFailed(true);
        console.error("Error sending email:", err);
      });
  }

  return (
    <div>
      <Helmet>
        <title>
          Custom Hydraulic Systems | Pillar Hydraulic Solutions Inc.
        </title>
        <meta
          name="description"
          content="Custom hydraulic systems with zero-emission engine starters. Trusted by industry leaders for quality, innovation, and environmental compliance."
        />

        <meta
          property="og:title"
          content="Custom Hydraulic Systems | Pillar Hydraulic Solutions Inc."
        />
        <meta
          property="og:description"
          content="Pillar provides zero-emission hydraulic engine starter packs and high-quality custom systems for the oil and gas industry."
        />
        <meta
          property="og:image"
          content={EmbedImg} // put an image here that is 1200x628
        />
        <meta property="og:url" content="https://pillarhydraulics.com/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="App">
        <NavBar onOpenModal={handleOpenModal} />
        <HomeHercSection onOpenModal={handleOpenModal} />
        <AboutUs onOpenModal={handleOpenModal} />
        <VideoSection onOpenModal={handleOpenModal} />
        <GetAQuote onOpenModal={handleOpenModal} />
        <PresentationSection onOpenModal={handleOpenModal} />
        <AdditionalProducts onOpenModal={handleOpenModal} />
        <Footer onOpenModal={handleOpenModal} />
        <Modal
          open={modalOpen}
          onCancel={handleCloseModal}
          onOk={handleCloseModal}
          width="100vw"
          footer={false}
          height="100vh"
          style={{
            position: "absolute",
            top: "0px",
            right: "0",
            left: "0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100vh",
              width: "100vw",
            }}
          >
            <div className="contactFormContainer">
              <div className="contactFormTitle">
                <h3>Engineered for durability.</h3>
                <img src={ContactLogo} className="contactFormImg" />
              </div>
              <div className="contactFormText">
                <h6>Send a message</h6>
                <h3>Request a call back.</h3>
                <div className="contactForm">
                  <div className="inputFlex">
                    <p className="bodyText">Name:</p>
                    <Input size="large" id="name" />
                  </div>
                  <div className="inputFlex">
                    <p className="bodyText">Email:</p>
                    <Input size="large" id="email" />
                  </div>
                  <div className="inputFlex">
                    <p className="bodyText">Phone:</p>
                    <Input size="large" id="phone" />
                  </div>
                  <div className="inputFlex">
                    <p className="bodyText">Message:</p>
                    <TextArea size="large" id="message" />
                  </div>
                </div>
                {formSuccess && (
                  <Tag color="green">Thanks, your form has been sent!</Tag>
                )}

                {formFailed && (
                  <Tag color="red">
                    Sorry, your form could not be sent. Please try again later.
                  </Tag>
                )}
                <button className="yellowBtn" onClick={sendEmail} type="submit">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default App;
